import {
  collection,
  deleteField,
  doc,
  DocumentReference,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase/config";

const ACTIVITY_COLLECTIONS = ["orders", "sessions", "transactions", "reservations"];
const STORE_SUBCOLLECTIONS = ["analytics", "auditLogs", "channelCounters", "pendingSessions"];

async function commitDeletes(refs: DocumentReference[]) {
  for (let index = 0; index < refs.length; index += 400) {
    const batch = writeBatch(db);
    refs.slice(index, index + 400).forEach((ref) => batch.delete(ref));
    await batch.commit();
  }
}

export async function startStoreProduction(storeId: string, cutoffDate: string) {
  const sessions = await getDocs(query(collection(db, "sessions"), where("storeId", "==", storeId)));
  const activeRefs: DocumentReference[] = [];
  for (const session of sessions.docs) {
    const active = await getDocs(query(collection(db, "activeSessions"), where("session", "==", session.id)));
    active.docs.forEach((item) => activeRefs.push(item.ref));
  }
  await commitDeletes(activeRefs);

  for (const name of ACTIVITY_COLLECTIONS) {
    const snap = await getDocs(query(collection(db, name), where("storeId", "==", storeId)));
    await commitDeletes(snap.docs.map((item) => item.ref));
  }

  for (const name of STORE_SUBCOLLECTIONS) {
    const snap = await getDocs(collection(db, "stores", storeId, name));
    await commitDeletes(snap.docs.map((item) => item.ref));
  }

  await updateDoc(doc(db, "stores", storeId), {
    storeMode: "production",
    productionCutoff: cutoffDate,
    counter: 0,
    limitFirstReachedDate: deleteField(),
    updated: serverTimestamp(),
  });
}
